import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const SmallBusinessHiringPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Small Business Hiring | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Small Business Hiring overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Small Business Hiring</h1>
        <p>Welcome to the small-business-hiring page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default SmallBusinessHiringPage
